export const requestErrorMessage = error => {
  if (!error) return ""
  const message = error.data?.responseMessage
  if (typeof message === "string" && message.trim()) return message.trim()
  const status = Number(error.statusCode ?? error.status ?? error.response?.status)
  if (status === 401) return "برای ادامه، دوباره وارد حساب کاربری شوید."
  if (status === 403) return "دسترسی لازم برای این عملیات را ندارید."
  if (status === 429) return "تعداد درخواست‌ها زیاد است؛ کمی بعد دوباره تلاش کنید."
  if (status >= 500) return "سرویس موقتاً در دسترس نیست؛ کمی بعد دوباره تلاش کنید."
  if (!status) return "ارتباط با سرور برقرار نشد؛ اتصال اینترنت را بررسی کنید."
  return "عملیات انجام نشد؛ اطلاعات واردشده را بررسی کنید."
}
